import { createSignal } from "solid-js";

export interface LocalStorageOptions<T> {
	key: string;
	onSerialize: (value: T) => string;
	onDeserialize: (value: string) => T;
}

export function createLocalStorage<T = string>(options: LocalStorageOptions<T>) {
	const initial = localStorage.getItem(options.key) || "";
	const deserialized = options.onDeserialize(initial);

	const [value, setValue] = createSignal<T>(deserialized);

	const update = (value: T) => {
		setValue(value as any);
		localStorage.setItem(options.key, options.onSerialize(value));
	};

	return [value, update] as const;
}
